<template>
    <div class="row border-bottom">
      <div class="col-lg-3">
        <label>
            {{label}}
        </label>
      </div>
      <div class="col-lg-6">
        <AGCInput name="密碼"
                  value="abcd"
                  required
                  disabled
                  type="password"
        ></AGCInput>
      </div>
      <div class="col-lg-3 text-right" v-if="enableEdit">
        <div>
          <b-button v-b-modal.modal
                    variant="light"
                    @click="success = false">
            修改密碼
          </b-button>
        </div>
      </div>
      <b-modal id="modal"
               ref="password-modal"
               size="sm"
               title="更改密碼"
               no-stacking
               centered
               :hide-header="success"
               :content-class="success ? 'success-modal-content' : 'change-password-modal-content'"
               :dialog-class="success ? 'success-modal-dialog' : 'change-password-modal-dialog'"
               :body-class="success ? 'success-modal-body' : 'change-password-modal-body'"
               :header-class="success ? 'success-modal-header' : 'change-password-modal-header'"
               :title-class="success ? 'success-modal-title' : 'change-password-modal-title'"
               hide-footer
               @hide="initialize()">
        <ValidationObserver ref="form">
          <form @submit.prevent
                v-stream:submit="onSubmit$"
                >
            <transition name="slide-left" mode="out-in">
              <div v-if="success"
                   key="'success'"
                   class="success-modal">
                <CustomLottie
                  :animationData="animationData"
                  style="margin-bottom: 24px;"
                ></CustomLottie>
                <span class="title">你已成功更改登入密碼</span>
                 <footer>
                   <b-button size="md"
                            variant="primary"
                            @click="hideModal"
                  >
                    完成
                  </b-button>
                </footer>
              </div>
              <div v-else
                  :key="'form'"
                  class="reset-password__frag"
              >
                <AGCInput v-model="oldPassword"
                          type="password"
                          name="舊密碼"
                          placeholder="舊密碼"
                          rules="required"
                          required
                ></AGCInput>
                <AGCInput v-model="newPassword"
                          type="password"
                          vid="password"
                          name="新密碼"
                          placeholder="新密碼"
                          rules="required|password"
                          required
                >
                  <template v-slot:invalidFeedback="{ errors }">
                    <span
                      style="font-size: 80%;"
                      :style="{ color: errors[0] ? '#dc3545' : '#7e8b97' }"
                    >
                      密碼最少8個字，必須包含數字及大，小寫英文字母（不支援特殊符號）。
                    </span>
                  </template>
                </AGCInput>
                <AGCInput v-model="confirmNewPassword"
                          type="password"
                          name="確認新密碼"
                          placeholder="確認新密碼"
                          rules="required|confirmed:password"
                          required
                ></AGCInput>
                <div class="row justify-content-end px-3">
                  <b-button size="md"
                            class="mr-2"
                            variant="light"
                            @click="hideModal"
                            >
                    取消
                  </b-button>
                  <b-button size="md"
                            type="submit"
                            variant="btn btn-primary"
                            :disabled="loading"
                  >
                    提交
                  </b-button>
                </div>
            </div>
          </transition>
        </form>
        </ValidationObserver>
      </b-modal>
    </div>
</template>

<script>
import {
  BButton,
  BModal,
} from 'bootstrap-vue';
import { switchMap, tap } from 'rxjs/operators';
import CustomLottie from '@/components/CustomLottie.vue';
import animationData from '@/assets/lottie/change-password-success.json';
import http from '../../helpers/http';
import { getErrorMsg } from '../../helpers/error-msg';
import toastSettings from '../../helpers/toast-settings';
import formMixin from '../../mixins/form';
import AGCInput from './AGCInput.vue';
import agcFormElementMixin from '../../mixins/agc-form-element';

export default {
  mixins: [agcFormElementMixin, formMixin],
  data: () => ({
    oldPassword: null,
    newPassword: null,
    confirmNewPassword: null,
    loading: false,
    success: false,
    animationData,
  }),
  components: {
    BButton,
    BModal,
    AGCInput,
    CustomLottie,
  },
  methods: {
    hideModal() {
      this.$refs['password-modal'].hide();
    },
    initialize() {
      this.oldPassword = null;
      this.newPassword = null;
      this.confirmNewPassword = null;
    },
  },
  domStreams: ['onSubmit$'],
  subscriptions() {
    return {
      submit: this.onSubmit$
        .pipe(
          switchMap(this.validate),
          tap(() => {
            this.loading = true;
          }),
          switchMap(() => http({
            method: 'POST',
            url: '/agc-merchant-api/auth/resetMerchantPassword',
            data: {
              username: this.inputVal.username,
              oldPassword: this.oldPassword,
              newPassword: this.newPassword,
            },
          }, {
            next: () => {
              this.success = true;
              this.initialize();
            },
            error: ({ data: { msg } }) => {
              this.$bvToast.toast(getErrorMsg(msg), {
                ...toastSettings,
                title: '錯誤',
                toaster: 'b-toaster-top-center',
              });
            },
            complete: () => {
              this.loading = false;
            },
          })),
        ),
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/transition/slide";

::v-deep {
  .change-password-modal {
    &-content {
      border: none;
    }

    &-dialog {
      max-width: 380px;
    }

    &-title {
      font-size: 18px;
      font-weight: 400;
      margin-left: 132px;
    }

    &-header {
      padding: 24px;
      border-bottom: none;
    }

    &-header .close {
      font-size: 19px;
      padding-top: 20px;
    }

    &-body {
      padding: 0 24px 24px 24px !important;

      .form-control {
        padding: 12px 14px !important;
        font-size: 15px !important;
        height: 100%;
        border: 1px solid #ced4d9;
      }
      .px-3 {
        padding-top: 8px;
      }
      .btn {
        padding: 9px 18px;
        min-width: 111px;

        &-light {
          margin-right: 12px !important;
          background-color: #f9f9fa;
          border: 1px solid #dde1e5;
          color: #636d77;
        }
      }
    }
  }

  .success-modal {
    display: inline-block;
    text-align: center;
    width: 100%;
    .title {
      display: block;
      font-size: 18px;
    }
    &-dialog {
      min-width: 380px;
    }

    &-content {
      border: none;
    }

    &-body {
      padding: 32px;
    }

    .btn {
      margin: 0 auto;
      min-width: 111px;
      padding: 9px 18px;
    }

    footer {
      border: none;
      padding: 28px 0 0 0;
    }
  }

  @font-face {
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 300;
    src: url(//fonts.gstatic.com/ea/notosanstc/v1/NotoSansTC-Light.woff2) format('woff2'),
      url(//fonts.gstatic.com/ea/notosanstc/v1/NotoSansTC-Light.woff) format('woff'),
      url(//fonts.gstatic.com/ea/notosanstc/v1/NotoSansTC-Light.otf) format('opentype');
  }
   .form-control {
    &::-moz-placeholder {
      color: #7e8b93;
      opacity: 1;
      font-weight: 300;
    }
    &:-ms-input-placeholder {
      color: #7e8b93;
      opacity: 1;
      font-weight: 300;
    }
    &::placeholder {
      color: #7e8b93;
      opacity: 1;
      font-weight: 300;
    }
  }
}
</style>
